import {Duration} from '../Domain/Duration';

export interface ScheduledEvent {
    id: number;
    startAt: Date;
    duration: Duration;
    recurrenceRule: RecurrenceRule | null;
}

export interface RecurrenceRule {
    frequency: Frequency;
    endAt: Date | null;
}

export enum Frequency {
    Daily = 'DAILY',
    Weekly = 'WEEKLY',
    Monthly = 'MONTHLY',
}
